import React from 'react';

interface ReceivablesRowProps {
    children: React.ReactNode;
}

/** Lines up a set of `ReceivablesTile` figures side by side. */
export const ReceivablesRow: React.FC<ReceivablesRowProps> = ({ children }) => (
    <dl className="flex gap-xs">
        {children}
    </dl>
);
